<template>
  <div>
    <v-card class="hvh-card--rounded px-4 py-4 mb-5">
      <!-- <div class="overflow-x"> -->
      <div class="hvh-flex mt-4">
        <div class="mr-3">
          <v-card class="mb-4 hvh-card--rounded pt-4 px-4">
            <h2 class="hvh-h7 mb-1">Year Range</h2>
            <CohortRangeFilter class="mb-4" v-model="yearFromTo" :min="yearMin" :max="yearMax" />
            <Loader v-if="isLoadingMinMaxYearAgeRange" />
          </v-card>
          <v-card class="mb-4 hvh-card--rounded pt-4 px-4">
            <h2 class="hvh-h7 mb-1">Age Range</h2>
            <CohortRangeFilter class="mb-4" v-model="ageFromTo" :min="ageMin" :max="ageMax" />
            <Loader v-if="isLoadingMinMaxYearAgeRange" />
          </v-card>

          <v-card class="mb-4 hvh-card--rounded p-4">
            <h2 class="hvh-h7 mb-1">Gender</h2>
            <div>
              <HvhInputCheckbox :value="[-1, 1].includes(filterObject.demo.sex)" text="Male" @input="sexChanged(1)" />
              <HvhInputCheckbox :value="[-1, 2].includes(filterObject.demo.sex)" text="Female" @input="sexChanged(2)" />
            </div>
          </v-card>
          <v-card class="mb-4 hvh-card--rounded p-4">
            <h2 class="hvh-h7 mb-1">Insurance Type</h2>
            <div>
              <HvhInputCheckbox
                :value="!(filterObject.demo.medicalInsurance || []).any() || filterObject.demo.medicalInsurance.includes(item)"
                :text="item"
                @input="medicalInsuranceChanged(item)"
                :key="item + ind"
                v-for="(item, ind) in demographics.insurances"
              />
            </div>
          </v-card>
          <v-card class="mb-4 hvh-card--rounded p-4">
            <h2 class="hvh-h7 mb-1">State</h2>
            <div>
              <CohortStateSelectFilter :value="filterObject.area.states" @input="statesChanged" />
            </div>
          </v-card>

          <HvhModal :title="histogramTarget" :value="!!histogramTarget" @input="histogramTarget = null" maxWidth="520px">
            <div class="hvh-flex column align-center">
              <h3 class="text-center">Time to transition</h3>
              <div class="hvh-flex">
                <h4 class="text-xs-center text-muted rotate-90">Count of patients</h4>
                <img class="histogram" :src="histogram" />
              </div>
              <h4 class="text-xs-center text-muted">Time to transition in days</h4>
            </div>
          </HvhModal>
        </div>
        <div class="charts col-7 col-sm-8 col-md-9 col-xl-10">
          <LiveFiltersRibbon class="pl-3" v-model="filterObject" :isFiltering="isFilteringAny" />

          <div class="pl-3 mt-3">
            <h3 class="text-center">Patient Timeline</h3>
            <PatientJourneyTimelineCharts :filterObject.sync="filterObject" @is-filtering="$set(isFiltering, 'timeline', $event)" />
            <h4 class="text-xs-center text-muted">Months</h4>
          </div>

          <h3 class="text-center mt-3">Drug Transitions</h3>
          <div class="position-relative" v-if="!showDrug">
            <SankeyFilter
              :data="drugTransitionData"
              :options="sankeyOptions"
              :filterObject="mergeFilter({ drugLinks: null })"
              :isFiltering="isFiltering.drugTransition"
              :isNodeChecked="isSankeyNodeChecked"
              :isLinkChecked="isSankeyLinkChecked"
              height="370px"
              :isEditMode="true"
              @checked-changed="sankeyItemClicked"
              @chart-created="loadDrugTransitionData"
              @refresh-data="loadDrugTransitionData"
            />
          </div>

          <div class="position-relative" v-else>
            <HvhChart :visualization="sankeyDrugData" :options="sankeyOptions" height="370px" @item-clicked="sankeyItemClicked" />
            <span class="top-right clickable" @click="showDrug = false">
              <VIcon color="#000">mdi-close</VIcon>
            </span>
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import HvhChart from '../../components/charts/HvhChart.vue';
import { getDemographics } from '../../libraries/cohorts';
import HvhInputCheckbox from '../../components/common/form/inputCheckbox/HvhInputCheckbox.vue';
import CohortRangeFilter from '../../components/analytics/cohorts/cohortFilters/CohortRangeFilter.vue';
import HvhModal from '../../components/common/modal/HvhModal.vue';
import { createFormData, errorDebug, valueDisplayFormat, } from '../../libraries/common';
import sankeyPerDrugEmpagliflozinData from './data/sankey per drug Empagliflozin.json';

import histogram from './data/histogram.png';
import { mergeFilters, } from '../../libraries/common';
import CohortStateSelectFilter from '../../components/analytics/cohorts/cohortFilters/CohortStateSelectFilter.vue';
import { stringifyLiveFilters } from '../../libraries/liveFilters';
import axios from '../../axios';
import PatientJourneyTimelineCharts from '../../components/patientJourney/PatientJourneyTimelineCharts.vue';
import SankeyFilter from '../../components/analysis/filters/SankeyFilter.vue';
import LiveFiltersRibbon from '../../components/analysis/filters/LiveFiltersRibbon.vue';

export default {
  components: { HvhChart, HvhInputCheckbox, CohortRangeFilter, HvhModal, CohortStateSelectFilter, PatientJourneyTimelineCharts, SankeyFilter, LiveFiltersRibbon, },
  props: ['cohortId', 'runId'],
  data() {
    var demographics = getDemographics();
    return {
      filterObject: {
        area: {
          states: []
        },
        demo: {
          ageFrom: demographics.ageRange[0],
          ageTo: demographics.ageRange[1],
          medicalInsurance: [],
          sex: -1,
        },
        cohortId: this.cohortId,
        runId: this.runId,
      },
      yearMin: demographics.years[0],
      yearMax: demographics.years[1],
      ageMin: demographics.ageRange[0],
      ageMax: demographics.ageRange[1],
      currentTimeline: null,
      showDrug: false,
      histogramTarget: false,
      demographics,
      histogram,
      sankeyOptions: {
        formatter: (params, data) => {
          if (params.dataType === 'edge') {
            return [
              // medianTime: 167
              // totalPatients: 0.958333
              `<b>${this.sankeyNodeName(params.data.source, data)}</b> to <b>${this.sankeyNodeName(params.data.target, data)}</b>`,
              `# of days between transitions: <b>${params.data.avgTime}</b>`,
              `% of Patients: <b>${valueDisplayFormat.percentages(params.data.totalPatients / params.data.cohortPatientsCount)}</b>`,
              `% of Females: <b>${valueDisplayFormat.percentages(params.data.femaleCount / params.data.totalPatients)} </b>`,
              `Average Age: <b>${params.data.medianAge}</b>`,
              `% Commercial: <b>${valueDisplayFormat.percentages(params.data.commercialInsCount / params.data.totalPatients)}</b>`,
              `% Other Insurance: <b>${valueDisplayFormat.percentages(params.data.otherInsCount / params.data.totalPatients)}</b>`,
              `% Medicare: <b>${valueDisplayFormat.percentages(params.data.medicareInsCount / params.data.totalPatients)}</b>`,
              `% Medicaid: <b>${valueDisplayFormat.percentages(params.data.medcaidInsCount / params.data.totalPatients)}</b>`,
            ].join('<br />');
          } else {
            return `<b>${params.data.name}</b>`;
          }
        },
      },
      drugTransitionData: null,
      timelineMin: 0,
      timelineMax: 0,
      isFiltering: {
        timeline: false,
        drugTransition: false,
      },
      isLoadingMinMaxYearAgeRange: false,
      cancelRequest: {},
    };
  },
  computed: {
    sankeyDrugData() {
      return {
        visualization_type: 'sankey',
        data: sankeyPerDrugEmpagliflozinData,
        ...this.sankeyOptions.tooltip
      };
    },
    ageFromTo: {
      get() {
        return [Math.max(this.filterObject.demo.ageFrom, this.ageMin), Math.min(this.filterObject.demo.ageTo, this.ageMax)];
      },
      set(value) {
        this.filterObject = {
          ...this.filterObject,
          demo: {
            ...this.filterObject.demo,
            ageFrom: parseInt(value[0]),
            ageTo: parseInt(value[1]),
          }
        };
      },
    },
    yearFromTo: {
      get() {
        var minMaxYears = [this.yearMin, this.yearMax];
        return [Math.max((this.filterObject.years || minMaxYears)[0], this.yearMin), Math.min((this.filterObject.years || minMaxYears)[1], this.yearMax)];
      },
      set(value) {
        this.filterObject = {
          ...this.filterObject,
          years: [...value.map(f => parseInt(f))],
        };
      }
    },
    isFilteringAny() {
      return Object.keys(this.isFiltering).find(key => this.isFiltering[key]);
    },
    selectedSankeyNodes() {
      return (this.filterObject.drugLinks || [])
        .reduce((acc, f) => { acc[f.source.id] = true; acc[f.target.id] = true; return acc; }, {});
    },
    selectedSankeyLinks() {
      return (this.filterObject.drugLinks || [])
        .reduce((acc, f) => { acc[`${f.source.id}-${f.target.id}`] = true; return acc; }, {});
    },
  },
  methods: {
    loadDrugTransitionData(filterObject) {
      if (this.cancelRequest.drugTransition)
        this.cancelRequest.drugTransition();
      this.isFiltering.drugTransition = true;
      axios.post('/PatientJourney/GetData', {
        component: "DrugTransitions",
        ...stringifyLiveFilters(filterObject),
      }, {
        cancelToken: new axios.CancelToken(c => this.cancelRequest.drugTransition = c)
      }).then(({ data }) => {
        this.drugTransitionData = {
          ...data,
          nodes: data.nodes.map(f => ({ value: f.totalPatients, ...f })),
          links: data.links.map(f => ({ value: f.totalPatients, ...f })),
        };
        this.isFiltering.drugTransition = false;
      }).catch((error) => {
        if (!axios.isCancel(error)) {
          console.log(error);
          this.isFiltering.drugTransition = false;
          this.disableIfTimeout(error);
        }
      });
    },
    getYearAndRangeData() {
      this.isLoadingMinMaxYearAgeRange = true;
      axios.post('/PatientJourney/GetYearAndAgeRange', createFormData({ runId: this.runId, cohortId: this.cohortId }))
        .then(({ data }) => {
          this.yearMin = data.minYearRange;
          this.yearMax = data.maxYearRange;
          this.ageMin = data.minAge;
          this.ageMax = data.maxAge;
        })
        .catch(errorDebug)
        .then(() => this.isLoadingMinMaxYearAgeRange = false);
    },

    sankeyNodeName(id, data) {
      return data.nodes.find(f => f.id === id).name;
    },
    sankeyItemClicked(event) {
      if (event.target) {
        var source = this.drugTransitionData.nodes.find(f => f.id === event.source);
        var target = this.drugTransitionData.nodes.find(f => f.id === event.target);

        var inCollection = (this.filterObject.drugLinks || [])
          .find(f => f.source.id === source.id && f.target.id === target.id);

        this.filterObject = {
          ...this.filterObject,
          drugLinks: !inCollection ?
            [...(this.filterObject.drugLinks || []), { source, target }]
            : this.filterObject.drugLinks.filter(f => f !== inCollection),
        };
      } else {
        // this.showDrug = event.title === 'Empagliflozin';
      }
    },
    isSankeyNodeChecked(event) {
      return this.selectedSankeyNodes[event.id];
    },
    isSankeyLinkChecked(event) {
      return this.selectedSankeyLinks[`${event.source}-${event.target}`];
    },
    medicalInsuranceChanged(event) {
      var medicalInsurance = !this.filterObject.demo.medicalInsurance?.any() ? this.demographics.insurances : this.filterObject.demo.medicalInsurance;
      this.filterObject = {
        ...this.filterObject,
        demo: {
          ...this.filterObject.demo,
          medicalInsurance: medicalInsurance.toggle(event),
        },
      };
    },
    sexChanged(event) {
      var sex = this.filterObject.demo.sex === -1 ? [1, 2].toggle(event).first() : -1;
      this.filterObject = {
        ...this.filterObject,
        demo: {
          ...this.filterObject.demo,
          sex,
        },
      };
    },
    statesChanged(event) {
      this.filterObject = {
        ...this.filterObject,
        area: {
          ...this.filterObject.area,
          states: event,
        },
      };
    },
    mergeFilter(obj) {
      return mergeFilters(this.filterObject, obj);
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisPatientJourney'] = this;
    this.getYearAndRangeData();
  }
}
</script>

<style lang="scss" scoped>
.top-right {
  position: absolute;
  top: 0;
  right: 0;
  margin: 10px 10px 0 0;
}
.rotate-90 {
  // text-orientation: mixed;
  transform: rotate(180deg);
  writing-mode: vertical-rl;
  text-orientation: sideways;
}

.charts {
  min-width: 500px;
}

.text-muted {
  color: #6e7079;
  font-size: 13px;
}

.histogram {
  width: 450px;
}
</style>